import Emitter from "./emmiter";
import Listener from "./listener";
import Mixin from "./mixin";
import Logger from "./logger";
import { Client } from './dist';
export default class WebPhone {


    constructor({ config, vuex, debug }) {
        Logger.debug = debug;
        Logger.info('VueWebPhone plugin enabled');

        console.log(`registrando`, config)
        //Bora instanciar o client do webphone passando os parametros vindo do app
        this.client = new Client(config)
        this.emitter = new Emitter(vuex);
        //passamos o client para o listener
        this.listener = new Listener(this.client, this.emitter, config.account);
        //Bora registrar 
        this.start(this.client);
    }
    async start(client) {
        //Essa porcaria mudou de register para connect
        try {
            await client.connect();
            console.log(client)
        } catch (e) {
            console.error(e)
        }

    }

    disconnect() {
        this.io = undefined;
        this.emitter.emit('disconnectConfig');
    }

    install(Vue) {
        Vue.prototype.$WebPhone = this;
        Vue.mixin(Mixin);
        Logger.info('VueWebPhone plugin enabled');
    }
}

